import { render } from "./dynamic_forms_setup.html?vue&type=template&id=4505a3ae&external"
import script from "./dynamic_forms_setup.js?vue&type=script&lang=js&external"
export * from "./dynamic_forms_setup.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__